import { createAction, props, union } from '@ngrx/store';

import {
  DisputeCategory,
  DisputeReason,
} from '@arc/unified-payments-frontend/shared-payment';

export const GetDisputeCategoriesAction = createAction(
  '[Dispute] Get Dispute Categories Action',
);

export const GetDisputeCategoriesCompleteAction = createAction(
  '[Dispute] Get Dispute Categories Complete Action',
  props<{ payload: DisputeCategory[] }>(),
);

export const GetDisputeCategoriesErrorAction = createAction(
  '[Dispute] Get Dispute Categories Error Action',
  props<{ payload: string }>(),
);

export const GetDisputeReasonsAction = createAction(
  '[Dispute] Get Dispute Reasons Action',
);

export const GetDisputeReasonsCompleteAction = createAction(
  '[Dispute] Get Dispute Reasons Complete Action',
  props<{ payload: DisputeReason[] }>(),
);

export const GetDisputeReasonsErrorAction = createAction(
  '[Dispute] Get Dispute Reasons Error Action',
  props<{ payload: string }>(),
);

const DisputeActions = union({
  GetDisputeCategoriesAction,
  GetDisputeCategoriesCompleteAction,
  GetDisputeCategoriesErrorAction,
  GetDisputeReasonsAction,
  GetDisputeReasonsCompleteAction,
  GetDisputeReasonsErrorAction,
});

export type DisputeActionsUnion = typeof DisputeActions;
